import React, { useState } from 'react';
import Icon from '../../ui/components/icon';
import { Grid, Column } from '../../ui/components/grid';
import Tooltip from '../../shared/components/tooltip';

import './compare-table.less';

export default function CompareTable(props) {
    const { compareResults, compareProducts } = props;
    if (!compareResults) return <div>Loading...</div>;
    if (compareProducts.length <= 1) return null;

    const [collapse, setCollapse] = useState(Array.from({ length: compareResults.length + 1 }, () => true));

    const lastCollapse = compareProducts.length + 1;
    let specCount = 0;

    const toggleCollapse = index => {
        const newCollapse = [...collapse];
        newCollapse[index] = !newCollapse[index];
        setCollapse(newCollapse);
    };

    const emptyItems = Array.from(Array(4 - compareProducts.length).keys());

    const offers = compareProducts.map(p => p.offers.reduce((acc, o) => [...acc, o.value], []).join('<br>'));
    return (
        <Grid className="product-table">
            {compareResults.map((n, i) => (
                <React.Fragment key={i}>
                    <Column className="title" desktop={12}>
                        <button type="button" onClick={() => toggleCollapse(i)}>
                            <span>{n.specCategory}</span>
                            <Icon name={collapse[i] ? 'minus_m' : 'plus_m'} />
                        </button>
                        {n.description && <div className="subtitle">{n.description}</div>}
                    </Column>
                    {n.specMapping.map((m, mi) => {
                        specCount += 1;
                        return (
                            <React.Fragment key={mi}>
                                <Column
                                    key={mi}
                                    className="category"
                                    columnClass={`col-title${mi % 2 === 0 ? ' even' : ''} ${
                                        collapse[i] ? 'show' : 'hide'
                                    }`}
                                    desktop={2}
                                    small={4}
                                    style={{ zIndex: 498 - specCount }}
                                >
                                    {m.description && (
                                        <Tooltip
                                            ariaLabel={n.description}
                                            displayOn="click"
                                            linkId={`compare:${m.title}`}
                                        >
                                            {m.description}
                                        </Tooltip>
                                    )}
                                    {!m.desciption && <span className="spacer" />}
                                    <div className="attrib">{m.title}</div>
                                </Column>
                                <div className={`desktop-10 subgrid ${collapse[i] ? 'show' : 'hide'}`}>
                                    {/** TODO: temporary fix to prevent crashing, some products have duplicate compare spec type */}
                                    {[...m.compare]
                                        .slice(0, 4)
                                        .reverse()
                                        .map((spec, si) => (
                                            <Column
                                                key={si}
                                                className="value"
                                                columnClass={`col-val${mi % 2 === 0 ? ' even' : ''}`}
                                                desktop={2}
                                                small={2}
                                            >
                                                {spec.map(specitem => (
                                                    <span dangerouslySetInnerHTML={{ __html: specitem }} />
                                                ))}
                                            </Column>
                                        ))}
                                    {/** TODO: temporary fix to prevent crashing, some products have duplicate compare spec type */}
                                    {[...Array(compareProducts.length - m.compare.slice(0, 4).length).keys()].map(k => (
                                        <Column
                                            columnClass={`col-val${mi % 2 === 0 ? ' even' : ''}`}
                                            key={k}
                                            desktop={2}
                                            small={2}
                                        />
                                    ))}
                                    <Column desktop={2} hide={['small', 'xs', 'xxs']} />
                                </div>
                            </React.Fragment>
                        );
                    })}
                </React.Fragment>
            ))}

            <Column className="title" desktop={12}>
                <button type="button" onClick={() => toggleCollapse(lastCollapse)}>
                    <span>offers</span>
                    <Icon name={collapse[lastCollapse] ? 'minus_m' : 'plus_m'} />
                </button>
                <div className="subtitle" />
            </Column>
            <Column
                className="category"
                columnClass={`col-title ${collapse[lastCollapse] ? 'show' : 'hide'}`}
                desktop={2}
                small={4}
            >
                {/* TODO: add tooltip and style once they provide description data */}
                {/* <Icon name="tooltip" className="attrib-tootlip" size={30} /> */}
                <span className="spacer" />
                <div className="attrib">Applicable offers</div>
            </Column>
            <div className={`desktop-10 subgrid ${collapse[lastCollapse] ? 'show' : 'hide'}`}>
                {offers.map((offer, i) => (
                    <Column key={i} className="value" columnClass="col-val" desktop={2} small={2}>
                        <span dangerouslySetInnerHTML={{ __html: offer }} />
                    </Column>
                ))}
                {emptyItems.map(k => (
                    <Column key={k} desktop={2} small={2} />
                ))}
                <Column desktop={2} hide={['small', 'xs', 'xxs']} />
            </div>
        </Grid>
    );
}
